import React, { Component } from 'react'
import { Button, Card, Drawer, Form, Modal, notification, Popconfirm, Tooltip } from 'antd'
import { TableComp } from 'sz-react-utils'
import Request from '../../request'
import moment from 'moment'
import _ from 'lodash'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { RightsWrapper } from '../../components/_utils/utils'

@Form.create()
class AddAccomodationService extends Component {
  state = {
    visible: true,
    id: null,
  }

  onClose = () => {
    setTimeout(() => {
      this.props.onClose()
    }, 50)
  }


  handleSubmit = e => {
    const { form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateAccomodationService(values)
        } else {
          x = await Request.addAccomodationService(values)
        }
        if (!x.error) {
          this.setState({
            id: '',
          })
          notification.success({
            message: x.msg
          })
          if (!this.state.id) {
            form.setFieldsValue({
              name: '',
              description: '',
              url: ''
            })

          }
          this.onClose();
        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  loadApi = () => {
    let { id } = this.props;
    if (id) {
      Request.getAccomodationServiceById({ id: id }).then(({ doc, error, message }) => {
        if (!error && doc) {
          this.setState({
            id: doc._id,
          })
          this.props.form.setFieldsValue({
            name: doc.name,
            description: doc.description,
            url: doc.url
          })
        } else {
          notification.error({
            message: 'Error Getting Data',
            description: message
          })
        }
      })
    }

  }


  componentDidMount() {
    this.loadApi();
  }



  render() {
    let { visible, id } = this.state;
    let { form: { getFieldDecorator } } = this.props;
    const inputTypes = {
      fields: [
        {
          label: 'Name',
          key: 'name',
          required: true
        },
        {
          label: 'Description',
          key: 'description',
          type: 'textarea',
          Row: 5,
          required: true
        },
        {
          label: 'URL',
          key: 'url',
          required: true
        }
      ]
    };
    return (
      <Drawer
        title={` ${id ? 'Edit' : 'Add'} Service`}
        placement="right"
        closable={true}
        onClose={this.onClose}
        visible={visible}
        width={600}
      >
        <Card bordered={true}>
          <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
            <GetAllFormFields
              inputSchema={inputTypes}
              refresh={this.refreshFxn}
              getFieldDecorator={getFieldDecorator}
            />
            <Button
              type=""
              htmlType="submit"
              style={{
                marginBottom: 10,
                marginLeft: '33%',
                backgroundColor: 'green',
                color: 'white'
              }}
              loading={this.props.loading}>
              SAVE
            </Button>
            <Button
              type="primary"
              style={{ marginBottom: 10, marginLeft: '1%' }}
              loading={this.props.loading}
              onClick={() => {
                this.props.form.resetFields()
              }}>
              RESET
            </Button>
          </Form>
        </Card>
      </Drawer>
    )
  }
}

class AccomodationServiceView extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    parentRatings: [],
    source: [],
    modalOpen: false,
    showDrawer: false
  }

  apiRequest = params => {
    return new Promise(async (resolve) => {
      let data = await Request.getAllAccomodationServices({ ...params })
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }


  openModelDrawer = (record) => {
    this.setState({ record: record, modalOpen: true })
  }

  componentWillMount() {

  }
  handleOk = () => {
    this.setState({ modalOpen: false, record: null })
  };
  handleCancel = () => {
    this.setState({ modalOpen: false, record: null })
  };


  showAddDrawer = () => {
    this.setState({ showDrawer: true });
  }

  closeDrawer = () => {
    this.setState({ showDrawer: false, id: '' }, () => {
      this.table.current.reload();
    })
  }

  deleteAccomodationService = async (data) => {
    let response = await Request.deleteAccomodationService(data)
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: response.message
      })
    }
    this.table.current.reload()
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  render() {
    let { modalOpen, record, showDrawer } = this.state
    const columns = [
      {
        title: 'Name',
        key: 'name'
      },
      {
        title: 'Details',
        key: 'details',
        render: (text, record) => (
          <Button onClick={() => this.openModelDrawer(record)}>Show Details</Button>
        )
      },
      // {
      //     title:'Description',
      //     key:'description'
      // },
      // {
      //     title:'URL',
      //     key:'url'
      // },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          record.businessId ?
            <React.Fragment>
              <RightsWrapper myRight={'accomodationServices.edit'}>
                <Tooltip title="Edit Accomodation Service">
                  <Button
                    shape="circle"
                    onClick={() => {
                      this.setState({ showDrawer: true, id: record._id })
                    }}
                    icon="edit"
                  />
                </Tooltip>
              </RightsWrapper>
              <RightsWrapper myRight={'accomodationServices.delete'}>
                <Tooltip title="Delete Accomodation Service">
                  <Popconfirm
                    title="Are you sure delete this Accomodation Service?"
                    onConfirm={() => {
                      this.deleteAccomodationService({ _id: record._id })
                    }}
                    okText="Yes"
                    cancelText="No">
                    <Button
                      shape="circle"
                      icon="delete"
                    />
                  </Popconfirm>
                </Tooltip>
              </RightsWrapper>
            </React.Fragment>
            : null
        )
      }
    ]
    return (
      <>
        <PageHeaderWrapper title={` Accomodation Services : ${this.state.total} `}>
          {
            showDrawer ?
              <AddAccomodationService id={this.state.id} onClose={this.closeDrawer} />

              : null
          }
          <RightsWrapper myRight={"accomodationServices.view"}>
            <Card bordered={true}>
              <Button type='primary' onClick={this.showAddDrawer}>Add</Button>
            </Card>
          </RightsWrapper>
          <Card bordered={true}>
            <TableComp
              ref={this.table}
              columns={columns}
              apiRequest={this.apiRequest}
              extraProps={{ scroll: { x: 900 } }}
              pagination={{
                showSizeChanger: true,
                defaultPageSize: 50,
                pageSizeOptions: ['10', '20', '50', '100', '1000']
              }}
            />
          </Card>

        </PageHeaderWrapper>
        {
          modalOpen ?
            <Modal title={record.name} visible={modalOpen} onOk={this.handleOk} onCancel={this.handleCancel} footer={[
              <Button key="book" href={record.url} target='_blank' type='primary'>Book Service</Button>
            ]}>
              <p>{record.description}</p>
            </Modal>

            : null
        }
      </>
    );
  }
}

export default AccomodationServiceView
